export const feeSliderRoute = 'fee-slider'